import { DetailedHTMLProps, HTMLAttributes } from 'react';

interface LauncherIconProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  color: string;
}

// Solution taken from https://ishadeed.com/article/thinking-about-the-cut-out-effect/

// - white fill in mask represent the area we want to show
// - black fill in mask represent the area we want to hide
// -- combination of white and black fill results in substraction
// -- combination of white and white results in union
export function LauncherIcon({ color, ...props }: LauncherIconProps) {
  return (
    <div {...props}>
      <svg
        role="img"
        aria-labelledby="giftboxLauncherIcon"
        height="60"
        width="65"
      >
        <title id="giftboxLauncherIcon">Giftbox launcher icon</title>

        {/* This is the mask that will be used to cut out the circle.  */}
        <mask id="circle">
          {/* White fill represent the are we want to show.  */}
          <circle fill="white" cx="28" cy="28" r="28"></circle>
          {/* Black fill represent the are we want to hide.  */}
          <circle fill="black" cx="53.75" cy="10" r="12"></circle>
        </mask>

        {/* Visible SVG part of the circle  */}
        <g mask="url(#circle)">
          <circle fill={color} cx="28" cy="28" r="28"></circle>
        </g>
      </svg>
    </div>
  );
}
